import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import VideoModal from 'client/components/VideoModal';

import PaddingContainer from './PaddingContainer';

const TechBanner = () => (
  <div className="main-banner-background">
    <div className="main-banner-pic-wrapper">
      <div
        className="main-banner-pic"
        style={{
          backgroundImage:
            'url(https://static.introwise.com/images/elements/main/stage-investor-day-annika-haas-blur.jpg)',
        }}
      />
    </div>
    <div className="main-banner-pic-text">
      <PaddingContainer>
        Network <b>smarter</b> at
        <br /> tech events
      </PaddingContainer>
    </div>
  </div>
);

const DanceBanner = () => (
  <div className="main-banner-background">
    <div className="main-banner-pic-wrapper">
      <div
        className="main-banner-pic"
        style={{
          backgroundImage: 'url(https://static.introwise.com/images/elements/main/people-dancing-unsplash-blur.jpg)',
        }}
      />
    </div>
    <div className="main-banner-pic-text">
      <PaddingContainer>
        Personalize the fun at
        <br /> dance events
      </PaddingContainer>
    </div>
  </div>
);

const RunningBanner = () => (
  <div className="main-banner-background">
    <div className="main-banner-pic-wrapper">
      <div
        className="main-banner-pic"
        style={{
          backgroundImage: 'url(https://static.introwise.com/images/elements/main/runners-start-elvet-barnes-blur.jpg)',
        }}
      />
    </div>
    <div className="main-banner-pic-text">
      <PaddingContainer>
        Break records together in
        <br /> running communities
      </PaddingContainer>
    </div>
  </div>
);

const MusicBanner = () => (
  <div className="main-banner-background">
    <div className="main-banner-pic-wrapper">
      <div
        className="main-banner-pic"
        style={{
          backgroundImage:
            'url(https://static.introwise.com/images/elements/main/four-people-on-the-wall-unsplash-blur.jpg)',
        }}
      />
    </div>
    <div className="main-banner-pic-text">
      <PaddingContainer>
        Split the cost at
        <br /> music events
      </PaddingContainer>
    </div>
  </div>
);

const UniqueBanner = () => (
  <div className="main-banner-background">
    <div className="main-banner-pic-wrapper">
      <div
        className="main-banner-pic"
        style={{
          backgroundImage:
            'url(https://static.introwise.com/images/elements/main/yoga-wrokshop-geert-pieters-unsplash-blur.jpg)',
        }}
      />
    </div>
    <div className="main-banner-pic-text">
      <PaddingContainer>
        Share your passion at
        <br /> unique events
      </PaddingContainer>
    </div>
  </div>
);

const bannersSequence = [TechBanner, DanceBanner, RunningBanner, UniqueBanner, MusicBanner];
const switchingInterval = 6 * 1000;
const fadeOutDuration = 1 * 1000;

class MainBannerBackground extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      number: 0,
      isFadingOut: false,
    };
  }

  componentDidMount() {
    this.interval = setInterval(this.nextBanner.bind(this), switchingInterval);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearTimeout(this.timeout);
  }

  nextBanner() {
    const next = (this.state.number + 1) % bannersSequence.length;
    this.setState({ number: next, isFadingOut: false });
    this.timeout = setTimeout(this.startFadeOut.bind(this), switchingInterval - fadeOutDuration);
  }

  startFadeOut() {
    this.setState({ isFadingOut: true });
  }

  render() {
    const CurrentBanner = bannersSequence[this.state.number];
    const { isFadingOut } = this.state;
    return (
      <div className={`main-banner-background-switch ${isFadingOut ? 'fade-out' : 'fade-in'}`}>
        <CurrentBanner />
      </div>
    );
  }
}

const mainBannerText = css`
  position: relative;
  color: #fff;
`;

const MainBannerStyled = styled.section`
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  z-index: 1;
  width: 100%;
  height: 460px;

  &:before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    background-color: rgba(59, 58, 108, 0.7);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }

  @media screen and (min-width: 768px) {
    height: 572px;
  }

  .main-banner-static {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 10;
    padding-bottom: 60px;
  }

  .main-banner-text {
    @media screen and (min-width: 1200px) {
      width: 60%;
      margin-left: 8.333%;
    }
  }

  .main-banner-title {
    ${mainBannerText}
    font-weight: bolder;
    font-size: 36px;
    line-height: 120%;
    letter-spacing: -0.02em;
    margin: 0 0 16px;
    br {
      display: none;
    }
    @media screen and (min-width: 768px) {
      font-size: 56px;
      line-height: 110%;
      .hide-desk {
        display: none;
      }
    }
    @media screen and (min-width: 992px) {
      br {
        display: block;
      }
    }
  }

  .main-banner-subtitle {
    ${mainBannerText}
    font-size: 16px;
    line-height: 140%;
    br {
      display: none;
    }
    @media screen and (min-width: 768px) {
      font-size: 26px;
    }
    @media screen and (min-width: 992px) {
      br {
        display: block;
      }
    }
  }

  .main-banner-video {
    position: absolute;
    bottom: 0;
    right: -50px;
    z-index: 100;
    width: 210px;
    height: 130px;

    cursor: pointer;
    .video-btn__bg {
      display: block;
      width: 100%;
      height: auto;
    }
    span {
      display: block;
      font-family: 'Caveat', cursive, sans-serif;
      font-size: 16px;
      line-height: 102%;
      letter-spacing: 0.01em;
      color: #fff;
      position: absolute;
      left: 15%;
      transition: transform 0.2s ease;
    }
    .video-btn__img {
      position: absolute;
      z-index: -1;
      top: 24%;
      width: 80%;
      left: 8%;
    }
    .video-btn__play {
      border-radius: 50%;
      font-size: 0;
      position: absolute;
      top: 62%;
      left: 50%;
      transition: transform 0.2s ease;
      box-shadow: 0px 0px 20px rgba(37, 38, 94, 0.12);
      transform: translate(-50%, -50%) scale(0.5);
    }
    .bg_stroke {
      transition: transform 0.2s ease;
    }
    &:hover {
      .video-btn__play {
        transform: translate(-50%, -50%) scale(0.6);
      }
      .bg_stroke {
        transform: translate(4%, -1%);
      }
      span {
        transform: translateX(-8%);
      }
    }
    @media (min-width: 768px) {
      width: 300px;
      height: 200px;
      span {
        font-size: 20px;
        left: 20%;
      }
      .video-btn__play {
        transform: translate(-50%, -50%) scale(0.7);
      }
      &:hover {
        .video-btn__play {
          transform: translate(-50%, -50%) scale(0.8);
        }
      }
    }
    @media (min-width: 992px) {
      width: 493px;
      height: 417px;
      right: -100px;
      span {
        font-size: 24px;
        left: 30%;
        top: 22px;
      }
      .video-btn__img {
        top: 19%;
        left: 8%;
      }
      .video-btn__play {
        top: 50%;
        transform: translate(-50%, -50%) scale(1);
      }
      &:hover {
        .video-btn__play {
          transform: translate(-50%, -50%) scale(1.1);
        }
      }
    }
  }

  .main-banner-background-switch {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }

  .main-banner-background {
    height: 100%;
    width: 100%;
    position: relative;
    background-color: rgb(59, 58, 108);

    .main-banner-pic-wrapper {
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
    }

    .main-banner-pic {
      z-index: -1;
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      filter: blur(4px);
    }

    .main-banner-pic-text {
      ${mainBannerText}
      position: absolute;
      bottom: 40px;
      left: 0;
      width: 100%;
      z-index: 50;
      font-family: 'Caveat';
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0.01em;
      @media screen and (min-width: 768px) {
        font-size: 24px;
        br {
          display: none;
        }
      }
    }
  }

  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOutOpacity {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes zoomIn {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.12);
    }
  }

  .main-banner-background-switch.fade-in {
    .main-banner-pic,
    .main-banner-text,
    .main-banner-action {
      opacity: 1;
      animation-name: fadeInOpacity;
      animation-iteration-count: 1;
      animation-timing-function: ease-in;
      animation-duration: 2s;
    }
  }

  .main-banner-background-switch.fade-out {
    .main-banner-pic,
    .main-banner-text,
    .main-banner-action {
      opacity: 0;
      animation-name: fadeOutOpacity;
      animation-iteration-count: 1;
      animation-timing-function: ease-in;
      animation-duration: 1s;
    }
  }

  .main-banner-background-switch {
    .main-banner-pic-wrapper {
      transform: scale(1.12);
      animation-name: zoomIn;
      animation-iteration-count: 1;
      animation-timing-function: ease-in;
      animation-duration: 6s;
    }
  }
`;

const MainBanner = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <MainBannerStyled>
      <MainBannerBackground />

      <div className="main-banner-static">
        <PaddingContainer>
          <div className="main-banner-text">
            <h1 className="main-banner-title">
              One platform for <span className="hide-desk">both</span> events
              <br /> and communities
            </h1>
            <div className="main-banner-subtitle">
              Introwise personalizes every participant{"'"}s experience,
              <br /> brings people together, and drives engagement
              <br /> and growth from&nbsp;events to&nbsp;communities.
            </div>
          </div>
        </PaddingContainer>
      </div>

      <div
        className="main-banner-video"
        onClick={() => setIsOpen(true)}
        onKeyPress={() => setIsOpen(true)}
        tabIndex={0}
        role="button"
      >
        <span>
          Hello, guest!
          <br />
          Watch the video
        </span>
        <svg
          className="video-btn__bg"
          xmlns="http://www.w3.org/2000/svg"
          width="493"
          height="678"
          fill="none"
          viewBox="0 0 493 678"
        >
          <path
            fill="#F86B6C"
            d="M488.4 211.3c1.8 8.4 3.6 17 4.1 25.5l-.5.6c-.8.1-.4-7.6-2.2-5.4-.5 9.5 1.1 19 .1 28.4 0-.8-.4-1.3-.5-2 0 .6-1 3.3-.4 4 .1.2.7.3.7.2 0 0 .6-.5.8-.3.6 1 .3 2.4.2 3.4-1.2-.7-2 1.7-2 2.6.1.7 1 2 1.3 2.6-.5.7-1.6-.4-1.7-.8 2 5.6-2.3 12.4 0 17.6-.6.7-1.6-1-2-.9-1.7.4-1.6 2.4-1.8 4-.3 2.1-.3 4.4-.3 6.6a26.2 26.2 0 0 0-4.3 11.1c0 2.1 1.3 2.5 1 5 1-1.9 1.8-3.9 2.6-5.9.2.1-2.8 11-2.8 11l.4-4.6c-2.4 5-2.4 10.8-4.4 16l2.1-2.3c-.5 2-.7 4.7-1.8 6.3-.5.8-1.6 1.3-2.3 2.4-.7 1-1.9 4.7-2.7 1.5-4.5 9.7-7.5 20-12.5 29.5.4-1 0-.5-.3-1.2a49.5 49.5 0 0 0-6.3 13.6c0-.2.5-2.6 0-2.9-2.6 4-3.6 8.4-5.8 12.5.3-1.4.2-2.4-1-1.2-1 .8-.5 3-1.2 4.5-.2-7.4-7.2 5.8-7.8 1.7 0 1-4.3 11.5-2.5 11-6.2 11.7-16 21-23.5 32 .4-1.3 2-3 1.8-4.3-.4-.2-.8 0-1 .6-7.9 9.2-14.2 19.5-22 28.8-2.5-1.6 10.3-11.2 8.3-13.8A1081 1081 0 0 1 369 483c-1.5 1.4-1.6 1-3.4 1.8-2.4 1-4.3 3.2-6 5.1-3.7 4.2-7 8.4-12.4 10.5 2 .6-5.8 7.4-6.2 7.7.6-1.8-3.6 1.1-3 0-1.4 1.6-13.4 14-15 10.4.3 2-6.4 5.8-5.6 6.4-.4.1-.8.2-1 .5 2.1 2.6 4.3 4.3 6.2 7.5-.2-2 2.7 2 3 2.1 1.2 2 2.4 4 3.7 5.8-.5-.6-.9-1-.9-.7-.2 3 3.5 6.2 5 8.6.8 1.6 1.6 3.2 1.4 5.1 0 .8-.9.4-.6 2 .1.6 1 1.1 1.4 1.8a22 22 0 0 1 2.3 5c1.1 3 2.3 7 1.7 10.2-.2-1.5-.9-2-1.6-3.3 6.3 22.5-.9 45.8-10.8 66l.3-4.5c-2.5 3-5 6-5.6 9.8-.5 3.3-1.2 5.5-3.5 8.1a78.8 78.8 0 0 1-24 17.6 96.8 96.8 0 0 1-46.3 10.4c-2.6 0-5.2 0-7.8-.3-1.5 0-7.4-1.5-8.4-.5 0 .1 2 1.3 2.1 1.6-2.5-.6-3.8-2.4-6.6-2.2l.5 1.3c-7.6-3.2-15.5-5.6-23-9.2-6.5-3.2-14.3-7.5-18-14-1.9-3-4.8-4.9-7.2-7.5a70.3 70.3 0 0 1-6.5-8.7c-.7-1-11-16.6-10-17.3.4-.2 1.3 1.1 1.5 1.4 0 0 .7.8.7.6.4-1-1.5-4-1.9-4.7a97 97 0 0 1-3.6-8 45.6 45.6 0 0 1-3.7-14.5c-.7-14 4.4-27.5 7.8-41v.8c.5.6 2.6-2.3 3.5-4.9 0-1-2.2 1.5-2.4 1.8a91 91 0 0 1 13.3-24.5c.2 1.1 4-.9 4.5-1-.2-.5-2.7-.4-3.3-.6-1-.4-1.7-1-2.5-1.8L172 519c-3-2.8-6-6.2-9.6-8-1.7-1-3.4-1.9-5.2-2.6-.9-.3-.8.2-1.7-.3-1-.5-2-1.7-2.9-2.3-5.3-4-10.6-8-15.7-12.5l-4.4-4c-.2-.2.2-.4-.3-.8s-1.4-.7-2-1c-2.8-2-4.8-7.3-8-8.3 0 0 2 .3 2.1-.3a61.7 61.7 0 0 1-4.8-3.8c5.7 3.6 2.1-4.4-.3-3.3-.4.2 1 1.5.4 1.8h-.7l.3-2.7c-2.8-2.5-4.9-1.2-2.4 2.1-9-9.2-18.6-17.8-27-27.7l1.8.1a73 73 0 0 1-9-10.2c-1-1.3-1.7-3-2.7-4.2 0 0-2.5-1.9-2-.5a8.7 8.7 0 0 1-2.9-3.3c-.5-1.2-.3-1.8-1.7-3 .5.4 2.3 2.2 3.2 2-3.5-3.6-9.4-7.8-11.3-12.2-2.2-5.2-4-10.2-8-14.4-.7.1-.2 2.1.8 3.6-.8-.8-2.4-2-2.8-3-.4-1 .1-2.3-.2-3.3-.6-2-3.5-3.4-5.3-5 .6-.2 1-.9 1.5-1.2-1.7-2.2-4.2-3.2-6.2-5-2-1.9-3-4.6-4.2-6.9a54.6 54.6 0 0 1-4.8-12.6l-.8-2.6h-.7a23.5 23.5 0 0 1-5-6.9c-1.2-2.5-2-5.2-3.7-7.4-.8-1-1-1.2-1.7-2.4-.7-1.4-.9-3.2-1.4-4.7-4.7-14-10-28-13-42.6l.7 1.3c0-5.9-4.8-10-5.3-16l1 2C6 274 3 260.4.6 248c.8 2.7 2.4-1.6 1.2-3-1-1.2-2 2.1-1.5-2.3.4 2 1-1 1-1.7 0-1.5-1-2.9-1.3-4.4-.7-5 1.4-11.7 2.3-16.8L6 200.2c.5-2.9.8-6 1.5-8.8.7-2.7 1-3.2 2.2-1a216 216 0 0 1 6.7-29.8c.3-1 .8-3.4 1.6-3.9 1.6-1 1.7.7 2.6-1.6.5-1.4-.3-2.7 0-4a8.5 8.5 0 0 1 2.2-4.5c-.3.5-1.7 4.8-1.5 6.3a17 17 0 0 0 3-8.3 17 17 0 0 1 2-7.3l1 3.4c2-2.6 3.3-5.3 3.2-8.6 0-3.3.1-6 2.4-8.7 1.3-1.4 3.1-2.3 4.6-3.4 2.5-1.9 4.6-4.6 6-7.5.3-.8.7-1.4.6-2.4 0-.7-.9-.2-1-.6-.6-1.6 0-2 1.2-3.7 2-2.6 3.5-5.3 5.2-8 1.3-2 4.6-8 7.1-8 3 0-1 2.1-.3 2.4.5.2 2-.5 2.2-.6L53 97.3c-.2.2 1.6-1.3 2-1 .4.4-4.9 6.3-3 6.6 4.3-4.9 7-11 10.7-16.4 1 1-4.5 5.8-1.2 5l1.7-3c-.3 1.2-.3 2-1.2 3 1.7.1 2.7-2.4 3.5-3.6.2-.3 1.3-1.5 1.3-1.8 0-.9-2.4-1.3-2.9-1.3 1.4-.2 2.3-3.2 3.1-4.3 1.3-1.8 2.8-3.5 4.3-5 2.8-3 6.2-6 8.3-9.7-.6 1.7 2-.6 2.1-.8 1.4-1.5 2.4-3.3 3.6-4.9 1-1.4 2.8-4.9 4.6-4.9.7 0 1 1 1.6 1 .8 0 1.2-.3 2-.7.6-.3 1.3-.9 1.7-1.3 1-1.2 1-.7.7-2 0-.7-.9-.9-.9-1.6 0-1.3 2.2-2.7 3-3.3 0 0-4.4 4.8-1 3.5 2-2.2 2.6-2.4 5.3-2.8 2.1-.3 9-4.9 8-7.5 2.5.4 4.3-.4 6.7-1-1.5-.2 6-6.4 5.2-7.4 2.2.8-2 3.8-1.3 5 1.3 2.3 5.2-2.6 6-3.3 1.3-1.2 3-2.4 4-3.9l.8-2.4c1.3-1.3 6.8-1.7 8.7-2.6a4 4 0 0 0-1.3 1.3c3.4-2.8 7.6-4.5 11.6-6.4 3.7-1.8 8.6-3.3 11.2-6.7-.3 2.3 7.2-.4 8-.7 1.1-.3 7.2-2.5 4.3.4 3.1-1 7-2.8 9.4-5 .3 2 10.4-.7 11.8-.9 1.7-.3 3.1-1.3 5-1.8 2.4-.7 5-1 7.3-2-1.3.6-1.8 1.1-1.2 1.7 2.4-1 3-.8 5.2-.4 1.4.2 4 1 4-1 0-.6-2.9-3 1.2-2 3.1.7-.7 1.1.7 2.5 3-1.6 6-4 9.3-3.2.4.1 1 .8 1.4 1 .6 0 2-.9 2.5-1 2.1-.8 4-1 6.1-.3l-6.5.5c2 1 2.4 1.2 4.4.7 3.6-.9 6-1.9 9.7-.8 1.5.4 2.8 2 4 2.3 1 .3 3.1-.3 4.2-.5-1.3 1.3-1.9 2.6-4 1.8 0 1-.6 2-.9 2.8a242 242 0 0 1 45.1 4.1c2.1.4 5.7 2 7.7 1.5.8-.2 1.8-1 2.6-1.5-5.4-1.4-16.6 1.4-20.4-3.4l3.5.1c-.2-1-1.8-1.7-2.8-2-.6-.2-7 .2-5.5 1.3l-2.5-.8c1.8-1.4 10.6-1 16-.4-.7.1-5.9.4-4.9 1.5 4.8.3 9.6 0 14.3.4-1.6.2-3 .8-4.4 1.6 2.2 1 3.3.6 5.3.4.8 0 2-.3 2.6 0 .2.1 2.5 1.6 1.1 2 4.8.4 9.2 1.6 13.6 3.7 0 0-4.7-.3-3.8 1 8.8 2.4 18.1 1.8 27 4.4 9 2.6 15.8 9.7 24.6 12.3.6-.3-2-2.2-1.9-2.7.1-.3 2.5.8 2.1.7-2.2 1.2 6.5 4.5 6.7 4.6 2.5 1.3 4.4 3.7 7.3 4.4-.7 0 2.6 3.5 2.6 3.5.5.7.7 1.7 1.3 2.8.3.6 0 .6-4.2-.5 7.2 2 12.2 9.4 19.8 10l-1.5-1.8 6.4 6.3-.3-.3c2.4 2.5 4.4 4.5 6.1 7.6-2.2-1.3-4-3-6.4-4.3 2.5 4.5 8.5 5.6 12.1 9-.9.7-4.3-3-4.3-1 2.4 2.5 5.6 4 8.2 6.2l-.9.2c1.4 2.1 2.4 3.2 4.6 3.8 2 .5 2.3.4 3.3 3 .2-.6 1.1-.2 1.2-.9.8 1.8 3.6 7.6-.7 4 1.8 2.1 4.1 4.3 6.7 5.4-.4-1.5-1.7-3-1.3-4.6 3.1 3 6 6.4 8.8 9.6 1 1.1-1.3-.4-2.4-1.8 6.4 15 21.1 24.5 24.5 41.2.2-1.9 1.8.4 2.3 1 1.4 1.8 2.1 4 3 6.1 1.8 4 3.7 8.2 4.6 12.5l-1.4-1.2c4.7 9.2 9.4 19 11.5 29 .4.3-1 .2-1.8-1 1.4 2.7 1.4 6 1.5 9.1.1 1.8-.4 5.6 2 6.3l-.3-2.4c.4 4.5 1.4 9.2 2.4 14.1-1-4.9 1.8 8.4 0 0zM207.7 3l-.6.2.6-.2zm-67.5 21.8l-.4.2.4-.2zM63.2 85H63zm371.4 320.5c.8-.2 1.2-1.6 1.6-2.3 1.3.6-2 4.3-2.5 5 .5-1.3 1.1-2.5 1-2.7.1.2 0 0 0 0zM249.8 571l.2-.3c-.2 2 .1.5-.4.8l.2-.6v.1zm2.6-.3l.3-.8c-.3-.6-.8.5-1.3 1.6l.5-1.5c-.3 0-1.3 2-1 2 .2-1 .3-1.5.2-1.8 0 .8-.3 1.4-.5 1.7.5-2 .1-3.7.5-5.6-.2 1-.7 3.8-1.2 4.5-.7 1-1.6.2-2.2 1.2 0-.5.4-1.3.1-1.7-.9-.7-1.5 2.7-1.7 3-.2-1.5.6-1.8.5-3.3a7 7 0 0 0-1.9 3.6c0-.6-.3-1-.6-1.5-.2.1-.2.3-.2.5v.6c-.5.1-.8-.2-.9-.8 0 0 .7 1.8.2 2.1-.2-.7-.7-1.2-.8-1.9 0 .1.2 1.2 0 1.2-.5.1-1.3-1.7-1.3-1.7.6 1.3-.2 1 .1 2-.8-.8-.3.8-1 .3 1.1 1.5.2.5.3 1.4 0-.3-.3-.5-.5-.7 0 0 .4 1.4 0 1l-1-1.3c.6 1 1.1 2.4 0 1.4l-.6-.9c.4 1.7-1.8 1.8-.8 3.6l-1.5-1.5c-.2 0-.4 0-.7-.2.3 0 2.3 3 2.6 2.8-1.8.3-6.5 1.3-2.6 2.7 0 0-1.8-.5-.9 0l1.1.3c-1.7-.3-.3 1.7-3.2 1.5 1.4.7-1 1.1 1.2 2-.7-.2-1.5-.2-2.2-.2.4.2 2.2.7 2.4 1.1.3.4-4 2-2 2.4-.2 0-1.7.5-1.5.6 1.3 0 2.4-.6 3.4.8-.9 0-1.6.7-2.4 1l2.5-.5c.3.4-1 1.8-1.2 2 1.2-.4 3.2-1.4 4.1 0l-.5.3c1.6-.8 0 .8.5.5l-1.5 1 .7-.2c-.6.3-2.4 1.3-2.5 1.7.8-.3 1.2-.9 2-1.2l-1.6 1.2c1 .2 3.6-3.4 4.2-.7l-1 .8c1 0 .4.8.2 1.2.4-.4 1-1.2 1.5-1.3.1 0-1.6 1.6-.2.7l-1.3 1 1.7-.8c-.7.7-1.7 2.8-.8 2.4.5-.6.6-1 1.2-1.5l-1.2 2 1.5-1.4-1 1.6c.2 0 2-1.8 2-1.9-.2 1.3-.8 2.5-1 3.8 1-1.9 1.2-.4 2-1.8-.4 2.4 1.4 1.7 1.7 3 0 1.3 1.4-2 1.4-1.8l-.2.5c.1 2.3 2-.3 2.2-1 0 0-.3 1.7 0 1.6-.3.6.1-2.2.2-1.9v1.2l.3-1.8c.3.6 1.4 3 2.3 1.5l.2 2c.8-.7.8-1.9 1.5-2.6l.5 2.1v-2l.3.5v1.1c.7 1.2 0-2 .3-2l.5 2.4c.6 1 0-2.3 0-2.7v-.7s1.8 4 2 2.7c-.5-1.6-1.3-2.3-.7-3.6.2-.4 1.7 2.8 1.8 3l-.7-.5c.7 1 .3 1.5.8 2.5.4.3.2-2 .2-2.2.4.8.3 1.4.8 2.2v-.7l.6 1.5c.2-1-.9-2.5-1.4-3.4l.2.4c-.4-1 .3-1.8 0-2.7l.4.8-.9-2.6s2 2.6 2 2.1c.1.1-2.2-2.9-2-3 .3.6.6 1.2 1.1 1.7-.2-.8 1.3 1.1 1.5 1.3-.5-.8-.4-1.2-1.2-2l2 1.8c-.9-.9-1.3-2-2-3 1.1 1.2 2 2.7 3.3 4-.9-1.4-1.5-2.7-2.6-3.8.7.4 1.3.7 2 1.3-.9-1.2-.2-1.6-1.5-2.9 1.2 1 2.1.8 3.3 1.8a7 7 0 0 0-1.5-1.8c1 .7 1.4.3 2.3.8-.8-.6-.6-.9-1.3-1.5l1.2.8c-1-.9 1.4.3 1.3.3-.7-.9-2-1-2.9-1.8 1 .1 1.8 1 2.6 1.3l-2.3-1.7c.3.1.8.2 1.5.6l-1-.8.6.1c.1.5.6.8 1.3.8l-1.4-1c1 0 2.1.4 3.2.8-.2 0-.4-.3-.5-.5l2 1h-.4c1 .3 1.8.7 2.6 1.1 1-2.8 2-3.6-.8-4.5-.2.2 1.7 1.4 1.5 1.6-.2.1-4.3-1-3-.3.2.1 1.1.5 1.5.5-1.2.1-2-.9-2.8-1.7l2.2 1c-.6-.7-1.3-1-2-1.5l2.3.8c.7 0-1-.6-1.2-.8l1.7.2c-1.9-1.5 2-.4 2.1-.4v-.2c-1-.8-3.9-1.2-4.6-2.3-.4-.6 1.4-.8 1.2-1.3-.3-.6-2 .1-2.4-.2l1.6-.2c-1.4-.2-.2-.6-1-.7 1.6.1 3-.8 4.8-.6-1.6-.2-1.9-1.7-4-.8l.7-.7c.8-1 1.5-.8 2.7-.6.2 0 .3-.2.5-.3 0-.5-1.9 0-2.2-.4.8-.2 1.4 0 2.2-.2.1-.3-1.3-.4-1.3-.4l.7-.2c1.1-.8-3.3.6-1.3-.4l-1.3.4c1-.5 2-1.2 3-1-.2-.9-3.5 1-4.5.2.2.5 1.7-1.2 1.6-.8.3-1.2-1-.2-1-.8 0-1-2.2.2.2-1.9-.7.5-1 .5-1.8.8.3-.9-.4-1.5 1-1.8-1.3 0-4 .1-1.7-1.3-.7.3.6-1.4.5-1.5-.2-.3-.9.7-1 1-.3-1.2-2.9 0-3.4-.2.2-.3 1.5-1 1.6-1.4.3-1.6-1.2-.2-1.3-1.3.2 0 .3-.3.5-.4.2-1-1.2 1.4-1.4 1.1l1-1.5-1 1.2c0-.2.5-1 1-1.4-.9.8-1.6.5-2.3 1.5.4-.9 1.2-1.7 1.6-2.6 0-.8-1 .5-1 .4-.3.6.2-1.6 0-1.5 0 0-1.8 2.8-2.3 3l.7-.9c0-.8-2 1.8-2.2 2 0 0 .8-3.2 1-3-1.7-1.2-2.4 1.1-3.3 1.3.3 0 .1 0 0 0zm8.5 23.8s.1 0 0 0c.1 0 0 0 0 0zm-20.3-18.7v-.2.2zm8.5 29c-.7 0 0 .3 0 1.1v-1.2c.1.6 0 0 0 0zm.7-.3c-.2 0-.4.2 0 0zm20.7-16H269c.5.1 1.4.7 1.5 0 0 0-.9 0 0 0zm-.5 3.2c.2.1.2 0 .2-.5l-1.7-.2 1.5.7zm-2.7-13c.5 0 1 0 1.5-.3-.2-.6-1 0-1.5.3.4-.2.4 0 0 0zm180.4-464.4c2.5-.9-1-4-2.6-3.9a88 88 0 0 0 2.6 4c-.9-1.4.5-.3 0 0zm-105-87.6c-1.2-2-2.6-3-5.2-2l5.1 2c-1.7-.7-.6-1 0 0zm-35.3-11.9c2.1-2.3-5.9-1.6-6.4-1.5l6.4 1.5c-2-.6.4-.5 0 0zm-297 174.1l.3-1.6-.7 3.4.4-1.8c0 .5.1-.7 0 0zm-2 9.6l-1.2 6.1c.3-.6 3.1-7 1.2-6 .7-.4-.4 2.2 0 0zm214 163c3.3-.5 4-.4 6.6.7 5 2.2 10.4 3.7 15.7 4.7 7.2 1.4 14.6 1.8 22 1.6 19.5-.7 38.8-6.2 57.1-13a510 510 0 0 0 52.7-24c15-7.7 31.6-14.7 41-29.3 10.7-16.5 13-38 15.1-57.2 2.1-18.6 1-36.9-11.6-51.7-6.4-7.5-14-13.6-20.7-20.9a115 115 0 0 1-15.6-24c-8.5-16.9-15-35.2-27-50.2a49.6 49.6 0 0 0-22.2-17c-7.8-2.6-16-2-23.9-.2-18.8 4.4-35.4 15.2-53.2 22.2a72.7 72.7 0 0 1-20.5 5.2c-3.2.3-5.6-1.6-9-2.8a75 75 0 0 0-16.2-3.9 122 122 0 0 0-50.5 6 331 331 0 0 0-54 23.1c-8.5 4.4-16.9 9-25.2 13.4-7 3.8-14 8-19.9 13.5-15 14.4-18 36.6-20.8 56.2-2.2 16.5-4.5 34.2 2 50 7.3 17.4 25 28 34.6 43.8 10.6 17.4 16.3 37.2 26.7 54.7 8.3 14 20.5 27.8 38 27.7 19.6 0 37.8-12.7 55-20.8a88.8 88.8 0 0 1 23.8-7.9c-3.5.5 1.6-.2 0 0z"
          />
          <mask id="a" fill="#fff">
            <path d="M220.3 360.5l-5 .4c-3.4.5-7.1 1.4-11 2.7l-.1.1h-.1c-8 2.8-16.5 7.1-25.1 11.6l-7 3.5-3.6 1.8a84.5 84.5 0 0 1-34.4 10.5h-.2c-6.2 0-12.1-1.5-17.7-5.2-14.1-9.1-23.3-26-30.7-42.8l-4-9.2c-6-14-12-28-21-39.3-2.4-3.1-5.1-5.9-7.8-8.7-1-1-2-1.9-2.8-2.9-7-7.1-14-14.2-18.1-23.8l-.3-.7-.2-.5v-.2c-5.7-14.3-4.5-30.9-2.5-46.8v-.4l.7-4.6c1.8-13.2 3.8-27.1 8.5-39a61.3 61.3 0 0 1 8-14.6 59 59 0 0 1 12.5-11.6l.2-.1c4-2.9 8.3-5.3 12.6-7.7l1.3-.7 10.3-5.6.2-.1a809 809 0 0 1 24.9-13.1l.2-.1c8.5-4.2 17.2-8.3 26-11.8l.3-.1c9.4-3.8 18.9-7.1 28.4-9.5l.2-.1a124.9 124.9 0 0 1 36-4.1 97.4 97.4 0 0 1 14 1.9c5.2 1.2 10.3 3 15.3 5.2l.2.1.3.1v.5c1.9-.1 3.8-.2 5.7-.5 3.8-.5 7.6-1.4 11.6-2.7h.4c8.5-2.8 17.5-7.1 26.5-11.6l7.3-3.5 3.9-1.8A93.5 93.5 0 0 1 320.6 65h.2c6.5 0 12.8 1.5 18.7 5.2 14.9 9.1 24.6 26 32.5 42.8l4.2 9.2c6.3 14 12.7 28 22.2 39.3 2.6 3.1 5.4 5.9 8.3 8.7l3 2.9a80.2 80.2 0 0 1 19 23.8l.4.7c0 .2 0 .3.2.5v.2c6.2 14.3 4.9 30.9 2.8 46.8l-.1.4-.6 4.6c-2 13.2-4 27.1-9 39l-2.1 4.5a51.2 51.2 0 0 1-19.7 21.7l-.2.1c-4.3 2.9-8.8 5.3-13.3 7.7l-1.4.7-11 5.6-.1.1a814 814 0 0 1-26.4 13.1l-.2.1c-9 4.2-18.2 8.3-27.6 11.8h-.2a242 242 0 0 1-30 9.5H289.9a139.2 139.2 0 0 1-32.8 4.2l-5.3-.1h-.1a113.6 113.6 0 0 1-14.7-1.9 90 90 0 0 1-16.2-5.2l-.5-.2v-.3z" />
          </mask>
          <path
            stroke="#fff"
            strokeWidth="2"
            d="M220.3 360.5l-5 .4c-3.4.5-7.1 1.4-11 2.7l-.1.1h-.1c-8 2.8-16.5 7.1-25.1 11.6l-7 3.5-3.6 1.8a84.5 84.5 0 0 1-34.4 10.5h-.2c-6.2 0-12.1-1.5-17.7-5.2-14.1-9.1-23.3-26-30.7-42.8l-4-9.2c-6-14-12-28-21-39.3-2.4-3.1-5.1-5.9-7.8-8.7-1-1-2-1.9-2.8-2.9-7-7.1-14-14.2-18.1-23.8l-.3-.7-.2-.5v-.2c-5.7-14.3-4.5-30.9-2.5-46.8v-.4l.7-4.6c1.8-13.2 3.8-27.1 8.5-39a61.3 61.3 0 0 1 8-14.6 59 59 0 0 1 12.5-11.6l.2-.1c4-2.9 8.3-5.3 12.6-7.7l1.3-.7 10.3-5.6.2-.1a809 809 0 0 1 24.9-13.1l.2-.1c8.5-4.2 17.2-8.3 26-11.8l.3-.1c9.4-3.8 18.9-7.1 28.4-9.5l.2-.1a124.9 124.9 0 0 1 36-4.1 97.4 97.4 0 0 1 14 1.9c5.2 1.2 10.3 3 15.3 5.2l.2.1.3.1v.5c1.9-.1 3.8-.2 5.7-.5 3.8-.5 7.6-1.4 11.6-2.7h.4c8.5-2.8 17.5-7.1 26.5-11.6l7.3-3.5 3.9-1.8A93.5 93.5 0 0 1 320.6 65h.2c6.5 0 12.8 1.5 18.7 5.2 14.9 9.1 24.6 26 32.5 42.8l4.2 9.2c6.3 14 12.7 28 22.2 39.3 2.6 3.1 5.4 5.9 8.3 8.7l3 2.9a80.2 80.2 0 0 1 19 23.8l.4.7c0 .2 0 .3.2.5v.2c6.2 14.3 4.9 30.9 2.8 46.8l-.1.4-.6 4.6c-2 13.2-4 27.1-9 39l-2.1 4.5a51.2 51.2 0 0 1-19.7 21.7l-.2.1c-4.3 2.9-8.8 5.3-13.3 7.7l-1.4.7-11 5.6-.1.1a814 814 0 0 1-26.4 13.1l-.2.1c-9 4.2-18.2 8.3-27.6 11.8h-.2a242 242 0 0 1-30 9.5H289.9a139.2 139.2 0 0 1-32.8 4.2l-5.3-.1h-.1a113.6 113.6 0 0 1-14.7-1.9 90 90 0 0 1-16.2-5.2l-.5-.2v-.3z"
            mask="url(#a)"
            className="bg_stroke"
          />
        </svg>
        <img
          className="video-btn__img"
          src="https://static.introwise.com/images/elements/main/mainBanner_video_bg.png"
          alt=""
        />
        <div className="video-btn__play">
          <svg width="97" height="97" viewBox="0 0 97 97" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="48.5" cy="48.5" r="48.5" fill="white" />
            <path
              d="M67.1081 47.1712C68.2973 47.8951 68.2973 49.7049 67.1081 50.4288L37.6757 68.3452C36.4865 69.0691 35 68.1643 35 66.7165V30.8835C35 29.4357 36.4865 28.5309 37.6757 29.2548L67.1081 47.1712Z"
              fill="#F86B6C"
            />
          </svg>
        </div>
      </div>

      <VideoModal
        videoSrc="https://www.youtube.com/embed/hn-_nPlQ0zM"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </MainBannerStyled>
  );
};

export default MainBanner;
